import React from 'react'

const LoadingDiv = () => {
  return <div className='loading-ring' />
}

export default LoadingDiv
